import { VarKey } from "@swivl-mono/types";
import { Button, ButtonColor, Dropdown, ImageUploader, ImageUploaderType, Input, Switch, TextArea } from "@swivl-mono/ui";
import { useEffect } from "react";
import { FiArrowLeft } from "react-icons/fi";
import { useNavigate, useParams } from "react-router-dom";
import { shallow } from "zustand/shallow";

import { ConversationRestrictionsControls } from "../../../Components/ConversationRestrictionsControls/ConversationRestrictionsControls";
import { QuestsDropdown } from "../../../Components/Dropdowns/QuestsDropdown/QuestsDropdown";
import BrandsModel from "../../../Models/Brands/Brands.Model";
import EmbedsModel from "../../../Models/Embeds/Embeds.Model";
import "./Embed.Details.View.scss";

export function EmbedDetailsView() {
  const { embeds } = EmbedsModel.useState((state) => state, shallow);
  const brands = BrandsModel.useState((state) => state.brands);

  const embedId = useParams().embedId;
  const embed = embeds && embedId ? embeds[parseInt(embedId)] : undefined;
  useEffect(() => {
    BrandsModel.load(false);
  }, []);
  const navigate = useNavigate();
  if (!embed) {
    return <div>Embed not found</div>;
  }
  const changeKey = (key: string, value: any) => {
    const b = { ...embed };
    (b as any)[key] = value;
    EmbedsModel.updateEmbed(b);
  };

  const changeSetting = (key: string, value: any, shouldSave = false) => {
    const b = { ...embed };
    (b.settings as any)[key] = value;
    EmbedsModel.updateEmbed(b, shouldSave);
  };
  const onBlur = () => {
    EmbedsModel.updateEmbed(embed, true);
  };
  const limitToGroup = embed.preloadVariables && embed.preloadVariables[VarKey.UserLimitToGroupId] ? true : false;

  return (
    <div className="p-5 EmbedDetailsView" key={"mykey" + embed.id}>
      <h3 className="mb-5">
        {" "}
        Chatbot Settings
        <Button
          className="ml-auto"
          color={ButtonColor.WHITE}
          onClickAsync={async () => {
            if (window.confirm("Are you sure you want to delete this embed?")) {
              await EmbedsModel.deleteEmbed(embed.id);
              navigate("/properties/page/chatbots");
            }
          }}
        >
          Delete Chatbot
        </Button>{" "}
      </h3>

      <div className="flex-row flex mb-4">
        <div className="pr-5">
          <label>Chat Avatar</label>
          <ImageUploader
            isEditable={true}
            imageURL={embed.settings.avatarURL}
            type={ImageUploaderType.AVATAR}
            imageUploaded={(url) => {
              changeSetting("avatarURL", url, true);
            }}
            text="Upload Image"
          />
        </div>

        <div className="position">
          <label>Position</label>
          <table className="positionTable">
            <tbody>
              <tr>
                <td>
                  <button
                    className={"arrowPick left" + (embed.settings.position == "left" ? " selected" : "")}
                    onClick={(e) => {
                      changeSetting("position", "left", true);
                    }}
                  >
                    <FiArrowLeft />
                  </button>
                </td>
                <td></td>
                <td>
                  <button
                    className={"arrowPick right" + (embed.settings.position == "right" ? " selected" : "")}
                    onClick={(e) => {
                      changeSetting("position", "right", true);
                    }}
                  >
                    <FiArrowLeft />
                  </button>
                </td>
              </tr>
              <tr>
                <td>
                  <button
                    className={"arrowPick bottomLeft" + (embed.settings.position == "bottom-left" ? " selected" : "")}
                    onClick={(e) => {
                      changeSetting("position", "bottom-left", true);
                    }}
                  >
                    <FiArrowLeft />
                  </button>
                </td>
                <td>
                  <button
                    className={"arrowPick bottomCenter" + (embed.settings.position == "bottom-center" ? " selected" : "")}
                    onClick={(e) => {
                      changeSetting("position", "bottom-center", true);
                    }}
                  >
                    <FiArrowLeft />
                  </button>
                </td>
                <td>
                  <button
                    className={"arrowPick bottomRight" + (embed.settings.position == "bottom-right" ? " selected" : "")}
                    onClick={(e) => {
                      changeSetting("position", "bottom-right", true);
                    }}
                  >
                    <FiArrowLeft />
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className=" w-1/2">
        <div className="mb-5">
          <div className="mb-10">
            <label>Embed Name (Private)</label>
            <Input
              name="Name"
              value={embed.name}
              onBlur={onBlur}
              onChange={(e) => {
                changeKey("name", e.target.value);
              }}
            />

            <label>Header Title</label>
            <Input
              name="headerText"
              value={embed.settings.headerText}
              onBlur={onBlur}
              onChange={(e) => {
                changeSetting("headerText", e.target.value);
              }}
            />

            <label>Collapsed Type</label>
            <Dropdown
              options={[
                { value: "bar", label: "Bar" },
                { value: "dot", label: "Dot" },
              ]}
              value={embed.settings.collapsedStyle ? embed.settings.collapsedStyle : "bar"}
              onChange={(event) => {
                changeSetting("collapsedStyle", event.target.value, true);
              }}
            />
            {embed.settings.collapsedStyle === "dot" && (
              <>
                <label>Dot Title</label>
                <Input
                  name="dotText"
                  value={embed.settings.dotText}
                  onBlur={onBlur}
                  onChange={(e) => {
                    changeSetting("dotText", e.target.value);
                  }}
                />
              </>
            )}

            <label>Color Theme</label>
            <Dropdown
              options={
                brands
                  ? Object.values(brands).map((brand) => {
                    return { value: brand.id, label: brand.name };
                  })
                  : []
              }
              value={embed.brandId}
              onChange={(event) => {
                changeKey("brandId", event.target.value);
              }}
            />
          </div>
          <div className="mb-10">
            <label>Call to Action Pop-up</label>
            <Switch
              on={embed.settings.showCTA || false}
              className="mb-2"
              onSet={(checked) => {
                changeSetting("showCTA", checked, true);
              }}
            />

            {embed.settings.showCTA && (
              <div className="mb-10">
                <label>CTA Title</label>
                <Input
                  value={embed.settings.ctaTitle}
                  onBlur={onBlur}
                  onChange={(e) => {
                    changeSetting("ctaTitle", e.target.value);
                  }}
                />

                <label>CTA Image URL</label>
                <Input
                  value={embed.settings.ctaImageURL}
                  onBlur={onBlur}
                  onChange={(e) => {
                    changeSetting("ctaImageURL", e.target.value);
                  }}
                />

                <label>CTA Body</label>
                <TextArea
                  value={embed.settings.ctaBody}
                  onBlur={onBlur}
                  onChange={(e) => {
                    changeSetting("ctaBody", e.target.value);
                  }}
                />

                <label>CTA Delay (seconds)</label>
                <TextArea
                  value={embed.settings.ctaDelay}
                  onBlur={onBlur}
                  onChange={(e) => {
                    changeSetting("ctaDelay", e.target.value);
                  }}
                />

                <label>CTA Start On Quest</label>
                <QuestsDropdown
                  value={embed.settings.ctaStartOnQuest}
                  onChange={(event) => {
                    changeSetting("ctaStartOnQuest", event.target.value, true);
                  }}
                />
              </div>
            )}
          </div>
          <ConversationRestrictionsControls
            restrictionsData={{
              defaultGroup: embed.preloadVariables?.[VarKey.UserDefaultGroup] ? parseInt(embed.preloadVariables[VarKey.UserDefaultGroup]) : undefined,
              startOnLocation: embed.preloadVariables?.[VarKey.UserLocationId] ? parseInt(embed.preloadVariables[VarKey.UserLocationId]) : undefined,
              limitedToGroupId: embed.preloadVariables?.[VarKey.UserLimitToGroupId]
                ? parseInt(embed.preloadVariables[VarKey.UserLimitToGroupId])
                : undefined,
            }}
            updateRestrictionsData={(data) => {
              const embedData = { ...embed };
              const preloadVariables: any = embedData.preloadVariables || {};
              if (!data.defaultGroup) {
                delete preloadVariables[VarKey.UserDefaultGroup];
              } else {
                preloadVariables[VarKey.UserDefaultGroup] = data.defaultGroup;
              }
              if (!data.startOnLocation) {
                delete preloadVariables[VarKey.UserLocationId];
              } else {
                preloadVariables[VarKey.UserLocationId] = String(data.startOnLocation);
              }
              if (!data.limitedToGroupId) {
                delete preloadVariables[VarKey.UserLimitToGroupId];
              } else {
                preloadVariables[VarKey.UserLimitToGroupId] = String(data.limitedToGroupId);
              }
              embedData.preloadVariables = preloadVariables;
              EmbedsModel.updateEmbed(embedData);
            }}
          />
          {/* 
          <label>Default Settings Group</label>
          
          <LocationsAndGroupsDropdown 
            type={LocationsAndGroupsDropdownType.GROUPS} 
            deselectLabel={"None"}
            onSelect={(groupId, _) => {
              let preloadVariables:any = embed.preloadVariables || {};
              preloadVariables[VarKey.UserDefaultGroup] = String(groupId)
              changeKey('preloadVariables', preloadVariables)
          }} groupId={embed.preloadVariables ? parseInt(embed.preloadVariables[VarKey.UserDefaultGroup]) : undefined}

          />


              <div className="my-3">
          <label>Limit to Group</label>
          <Switch
            on={limitToGroup}
            className="mb-2"
            onSet={(checked) => {
              let preloadVariables:any = embed.preloadVariables || {};
              

              if (!checked) {
                delete preloadVariables[VarKey.UserLimitToGroupId]
              } else {
                preloadVariables[VarKey.UserLimitToGroupId] = groups && Object.values(groups).length ? String(Object.values(groups)[0].id) : ""
              }
              changeKey('preloadVariables', preloadVariables)
              
              
            }} />
            {limitToGroup &&   <LocationsAndGroupsDropdown 
            type={LocationsAndGroupsDropdownType.GROUPS} 
            onSelect={(groupId, _) => {
              let preloadVariables:any = embed.preloadVariables || {};
              preloadVariables[VarKey.UserLimitToGroupId] = String(groupId)
              changeKey('preloadVariables', preloadVariables)

          }} groupId={embed.preloadVariables ? parseInt(embed.preloadVariables[VarKey.UserLimitToGroupId]) : undefined}

          />
            }
</div> */}
        </div>
      </div>
    </div>
  );
}
